import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { io } from "socket.io-client";
import {rootEnv} from "src/environments/config";


@Injectable({
  providedIn: 'root'
})
export class LeadSocketService {

  public socketData: BehaviorSubject<any> = new BehaviorSubject({});
  socket:any;

  forLeadPage:BehaviorSubject<any> = new BehaviorSubject(0);
  forLeadDetailPage:BehaviorSubject<any> = new BehaviorSubject(0);
  forAgentPage:BehaviorSubject<any> = new BehaviorSubject(0);



  constructor() {}



  
  


  conectIO()
  {
    let self = this;
   // this.socket = io(rootEnv.config.webSocket, {path: "/websocket/socket.io"});
    this.socket = io(rootEnv.config.webSocket);
       
    
    this.socket.on('connect', function() 
    {
      
          
    });

    this.socket.on('connect_failed', function() {
      document.write("Sorry, there seems to be an issue with the connection!");
   })

  }


  disconnect()
  {
    this.socket?.disconnect();

  }



  public emitData(dataVar: any) {
   
    this.socket?.emit(dataVar.target, {...dataVar.dataParam});
  }

  public getData = () => {
    this.socket?.on('afterConnection', (dataParam:any) =>{
      this.socketData.next(dataParam);
    });

    this.socket?.on('leadRowStatus', (dataParam:any) =>{
      //this.socketData.next(dataParam);
    });

    this.socket?.on('ReminderNotification', (dataParam:any) =>{
      this.socketData.next(dataParam);
    });

    this.socket?.on('freeLeadNotification', (dataParam:any) =>{
      this.socketData.next(dataParam);
    });

    this.socket?.on('leadAssigned', (dataParam:any) =>{
      
      //this.socketData.next(dataParam);
    });

    this.socket?.on('roundRobin', (dataParam:any) =>{
      this.socketData.next(dataParam);
    });

    this.socket?.on('reminderORcancel', (dataParam:any) =>{
      //this.socketData.next(dataParam);
    });

    this.socket?.on('bookingLead', (dataParam:any) =>{
      this.socketData.next(dataParam);
    });

    this.socket?.on('appReload', (dataParam:any) =>{
      
      this.socketData.next(dataParam);
    });




    this.socket?.on('agentEvent', (dataParam:any) =>{
      this.socketData.next({targetEvent:'agentEvent', ...dataParam});
    });

    

    return this.socketData.asObservable();
  };
  


}
